module.exports = __webpack_public_path__ + "img/freeTime.1ecf4d29.png";